import React from "react";

export const PlanetSVG = ({ className, style }) => (
    <svg
        viewBox="0 0 200 200"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient id="planetGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff5f56" />
                <stop offset="100%" stopColor="#ffbd2e" />
            </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="80" fill="url(#planetGradient)" opacity="0.8" />
        <path
            d="M20 100 Q100 180 180 100"
            fill="none"
            stroke="rgba(255,255,255,0.3)"
            strokeWidth="5"
        />
        <circle cx="60" cy="70" r="10" fill="rgba(255,255,255,0.2)" />
        <circle cx="140" cy="130" r="15" fill="rgba(255,255,255,0.1)" />
    </svg>
);

export const RocketSVG = ({ className, style }) => (
    <svg
        viewBox="0 0 512 512"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M256 16c-50 0-90 40-90 90v120c0 30-20 70-50 90 0 0-20 10-20 40s30 40 30 40c20 0 40-20 60-30 0-20 20-30 40-30h60c20 0 40 10 40 30 20 10 40 30 60 30 0 0 30-10 30-40s-20-40-20-40c-30-20-50-60-50-90V106c0-50-40-90-90-90z"
            fill="#f0f0f0"
        />
        <path d="M256 16v340" stroke="#ddd" strokeWidth="2" />
        <path
            d="M166 226v80c0 20-20 40-40 40h-10c0-20 10-30 30-40v-80c-20-10-30-20-30-40h10c20 0 40 20 40 40z"
            fill="#ff5f56"
        />
        <path
            d="M346 226v80c0 20 20 40 40 40h10c0-20-10-30-30-40v-80c20-10 30-20 30-40h-10c-20 0-40 20-40 40z"
            fill="#ff5f56"
        />
        <circle cx="256" cy="120" r="30" fill="#282c34" />
        <circle cx="256" cy="120" r="24" fill="#61dafb" />
    </svg>
);

export const StarsSVG = ({ className, style }) => (
    <svg
        viewBox="0 0 200 200"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="20" cy="30" r="2" fill="#fff" opacity="0.8" />
        <circle cx="80" cy="10" r="1.5" fill="#fff" opacity="0.6" />
        <circle cx="150" cy="40" r="2.5" fill="#fff" opacity="0.9" />
        <circle cx="50" cy="150" r="1.5" fill="#fff" opacity="0.7" />
        <circle cx="180" cy="160" r="2" fill="#fff" opacity="0.8" />
        <path
            d="M100 80 L102 85 L108 86 L103 90 L104 96 L100 92 L96 96 L97 90 L92 86 L98 85 Z"
            fill="#f78166"
        />
    </svg>
);

export const UfoSVG = ({ className, style }) => (
    <svg
        viewBox="0 0 512 512"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M256 128c-80 0-138 30-150 70 0 0-30 10-30 40 0 20 20 40 50 50 20 30 60 50 130 50s110-20 130-50c30-10 50-30 50-50 0-30-30-40-30-40-12-40-70-70-150-70z"
            fill="#e0e0e0"
        />
        <ellipse cx="256" cy="180" rx="60" ry="30" fill="#61dafb" opacity="0.8" />
        <path
            d="M166 238c0 0 0 0 0 0 20 30 60 50 90 50s70-20 90-50"
            fill="none"
            stroke="#bbb"
            strokeWidth="5"
            strokeLinecap="round"
        />
        <circle cx="120" cy="240" r="5" fill="#f78166" />
        <circle cx="392" cy="240" r="5" fill="#f78166" />
        <circle cx="256" cy="290" r="5" fill="#f78166" />
    </svg>
);

export const ConstellationSVG = ({ className, style }) => (
    <svg
        viewBox="0 0 200 200"
        className={className}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="40" cy="40" r="4" fill="#fff" />
        <circle cx="160" cy="60" r="3" fill="#fff" />
        <circle cx="100" cy="140" r="5" fill="#fff" />
        <circle cx="180" cy="160" r="3" fill="#fff" />
        <circle cx="60" cy="180" r="4" fill="#fff" />

        <line x1="40" y1="40" x2="160" y2="60" stroke="#f78166" strokeWidth="1" opacity="0.5" />
        <line x1="160" y1="60" x2="100" y2="140" stroke="#f78166" strokeWidth="1" opacity="0.5" />
        <line x1="100" y1="140" x2="180" y2="160" stroke="#f78166" strokeWidth="1" opacity="0.5" />
        <line x1="100" y1="140" x2="60" y2="180" stroke="#f78166" strokeWidth="1" opacity="0.5" />
        <line x1="60" y1="180" x2="40" y2="40" stroke="#f78166" strokeWidth="1" opacity="0.5" />
    </svg>
);
